(() => {
  "use strict";
  var e = {
      d: (t, n) => {
        for (var r in n)
          e.o(n, r) &&
            !e.o(t, r) &&
            Object.defineProperty(t, r, { enumerable: !0, get: n[r] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  function isNumber(e) {
    return "number" == typeof e;
  }
  function isString(e) {
    return "string" == typeof e;
  }
  function isBoolean(e) {
    return "boolean" == typeof e;
  }
  function isObject(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }
  function mathAbs(e) {
    return Math.abs(e);
  }
  function mathSign(e) {
    return Math.sign(e);
  }
  function deltaAbs(e, t) {
    return mathAbs(e - t);
  }
  function arrayKeys(e) {
    return objectKeys(e).map(Number);
  }
  function arrayLast(e) {
    return e[arrayLastIndex(e)];
  }
  function arrayLastIndex(e) {
    return Math.max(0, e.length - 1);
  }
  function arrayIsLastIndex(e, t) {
    return t === arrayLastIndex(e);
  }
  function arrayFromNumber(e, t = 0) {
    return Array.from(Array(e), (e, n) => t + n);
  }
  function objectKeys(e) {
    return Object.keys(e);
  }
  function objectsMergeDeep(e, t) {
    return [e, t].reduce(
      (e, t) => (
        objectKeys(t).forEach((n) => {
          const r = e[n],
            o = t[n],
            i = isObject(r) && isObject(o);
          e[n] = i ? objectsMergeDeep(r, o) : o;
        }),
        e
      ),
      {}
    );
  }
  function isMouseEvent(e, t) {
    return void 0 !== t.MouseEvent && e instanceof t.MouseEvent;
  }
  function EventStore() {
    let e = [];
    const t = {
      add: function add(n, r, o, i = { passive: !0 }) {
        let s;
        if ("addEventListener" in n)
          n.addEventListener(r, o, i),
            (s = () => n.removeEventListener(r, o, i));
        else {
          const e = n;
          e.addListener(o), (s = () => e.removeListener(o));
        }
        return e.push(s), t;
      },
      clear: function clear() {
        e = e.filter((e) => e());
      },
    };
    return t;
  }
  function Animations(e, t, n, r) {
    const o = EventStore(),
      i = 1e3 / 60;
    let s = null,
      a = 0,
      c = 0;
    function animate(e) {
      if (!c) return;
      s || (s = e);
      const o = e - s;
      for (s = e, a += o; a >= i; ) n(i), (a -= i);
      r(a / i), c && t.requestAnimationFrame(animate);
    }
    function stop() {
      t.cancelAnimationFrame(c), (s = null), (a = 0), (c = 0);
    }
    return {
      init: function init() {
        o.add(e, "visibilitychange", () => {
          e.hidden &&
            (function reset() {
              (s = null), (a = 0);
            })();
        });
      },
      destroy: function destroy() {
        stop(), o.clear();
      },
      start: function start() {
        c || (c = t.requestAnimationFrame(animate));
      },
      stop,
      update: () => n(i),
      render: r,
    };
  }
  function Limit(e = 0, t = 0) {
    const n = mathAbs(e - t);
    function reachedMin(t) {
      return t < e;
    }
    function reachedMax(e) {
      return e > t;
    }
    function reachedAny(e) {
      return reachedMin(e) || reachedMax(e);
    }
    return {
      length: n,
      max: t,
      min: e,
      constrain: function constrain(n) {
        return reachedAny(n) ? (reachedMin(n) ? e : t) : n;
      },
      reachedAny,
      reachedMax,
      reachedMin,
      removeOffset: function removeOffset(e) {
        return n ? e - n * Math.ceil((e - t) / n) : e;
      },
    };
  }
  function Counter(e, t, n) {
    const { constrain: r } = Limit(0, e),
      o = e + 1;
    let i = withinLimit(t);
    function withinLimit(e) {
      return n ? mathAbs((o + e) % o) : r(e);
    }
    function get() {
      return i;
    }
    function clone() {
      return Counter(e, get(), n);
    }
    const s = {
      get,
      set: function set(e) {
        return (i = withinLimit(e)), s;
      },
      add: function add(e) {
        return clone().set(get() + e);
      },
      clone,
    };
    return s;
  }
  function DragHandler(
    e,
    t,
    n,
    r,
    o,
    i,
    s,
    a,
    c,
    u,
    l,
    d,
    f,
    m,
    p,
    g,
    h,
    b,
    v
  ) {
    const { cross: S, direction: L } = e,
      E = ["INPUT", "SELECT", "TEXTAREA"],
      A = { passive: !1 },
      w = EventStore(),
      D = EventStore(),
      I = Limit(50, 225).constrain(m.measure(20)),
      T = { mouse: 300, touch: 400 },
      M = { mouse: 500, touch: 600 },
      P = p ? 43 : 25;
    let C = !1,
      O = 0,
      B = 0,
      N = !1,
      k = !1,
      z = !1,
      F = !1;
    function move(e) {
      if (!isMouseEvent(e, r) && e.touches.length >= 2) return up(e);
      const t = i.readPoint(e),
        n = i.readPoint(e, S),
        s = deltaAbs(t, O),
        c = deltaAbs(n, B);
      if (!k && !F) {
        if (!e.cancelable) return up(e);
        if (((k = s > c), !k)) return up(e);
      }
      const l = i.pointerMove(e);
      s > g && (z = !0),
        u.useFriction(0.3).useDuration(0.75),
        a.start(),
        o.add(L(l)),
        e.preventDefault();
    }
    function up(e) {
      const t = l.byDistance(0, !1).index !== d.get(),
        n =
          i.pointerUp(e) *
          (function forceBoost() {
            return (p ? M : T)[F ? "mouse" : "touch"];
          })(),
        r = (function allowedForce(e, t) {
          const n = d.add(-1 * mathSign(e)),
            r = l.byDistance(e, !p).distance;
          return p || mathAbs(e) < I
            ? r
            : h && t
            ? 0.5 * r
            : l.byIndex(n.get(), 0).distance;
        })(L(n), t),
        o = (function factorAbs(e, t) {
          if (0 === e || 0 === t) return 0;
          if (mathAbs(e) <= mathAbs(t)) return 0;
          const n = deltaAbs(mathAbs(e), mathAbs(t));
          return mathAbs(n / e);
        })(n, r),
        s = P - 10 * o,
        a = b + o / 50;
      (k = !1),
        (N = !1),
        D.clear(),
        u.useDuration(s).useFriction(a),
        c.distance(r, !p),
        (F = !1),
        f.emit("pointerUp");
    }
    function click(e) {
      z && (e.stopPropagation(), e.preventDefault(), (z = !1));
    }
    return {
      init: function init(e) {
        if (!v) return;
        function downIfAllowed(a) {
          (isBoolean(v) || v(e, a)) &&
            (function down(e) {
              const a = isMouseEvent(e, r);
              if (
                ((F = a),
                (z = p && a && !e.buttons && C),
                (C = deltaAbs(o.get(), s.get()) >= 2),
                a && 0 !== e.button)
              )
                return;
              if (
                (function isFocusNode(e) {
                  const t = e.nodeName || "";
                  return E.includes(t);
                })(e.target)
              )
                return;
              (N = !0),
                i.pointerDown(e),
                u.useFriction(0).useDuration(0),
                o.set(s),
                (function addDragEvents() {
                  const e = F ? n : t;
                  D.add(e, "touchmove", move, A)
                    .add(e, "touchend", up)
                    .add(e, "mousemove", move, A)
                    .add(e, "mouseup", up);
                })(),
                (O = i.readPoint(e)),
                (B = i.readPoint(e, S)),
                f.emit("pointerDown");
            })(a);
        }
        const a = t;
        w.add(a, "dragstart", (e) => e.preventDefault(), A)
          .add(a, "touchmove", () => {}, A)
          .add(a, "touchend", () => {})
          .add(a, "touchstart", downIfAllowed)
          .add(a, "mousedown", downIfAllowed)
          .add(a, "touchcancel", up)
          .add(a, "contextmenu", up)
          .add(a, "click", click, !0);
      },
      destroy: function destroy() {
        w.clear(), D.clear();
      },
      pointerDown: function pointerDown() {
        return N;
      },
    };
  }
  function DragTracker(e, t) {
    let n, r;
    function readTime(e) {
      return e.timeStamp;
    }
    function readPoint(n, r) {
      const o = "client" + ("x" === (r || e.scroll) ? "X" : "Y");
      return (isMouseEvent(n, t) ? n : n.touches[0])[o];
    }
    return {
      pointerDown: function pointerDown(e) {
        return (n = e), (r = e), readPoint(e);
      },
      pointerMove: function pointerMove(e) {
        const t = readPoint(e) - readPoint(r),
          o = readTime(e) - readTime(n) > 170;
        return (r = e), o && (n = e), t;
      },
      pointerUp: function pointerUp(e) {
        if (!n || !r) return 0;
        const t = readPoint(r) - readPoint(n),
          o = readTime(e) - readTime(n),
          i = readTime(e) - readTime(r) > 170,
          s = t / o;
        return o && !i && mathAbs(s) > 0.1 ? s : 0;
      },
      readPoint,
    };
  }
  function ResizeHandler(e, t, n, r, o, i, s) {
    const a = [e].concat(r);
    let c,
      u,
      l = [],
      d = !1;
    function readSize(e) {
      return o.measureSize(s.measure(e));
    }
    return {
      init: function init(o) {
        i &&
          ((u = readSize(e)),
          (l = r.map(readSize)),
          (c = new ResizeObserver((n) => {
            (isBoolean(i) || i(o, n)) &&
              (function defaultCallback(n) {
                for (const i of n) {
                  if (d) return;
                  const n = i.target === e,
                    s = r.indexOf(i.target),
                    a = n ? u : l[s];
                  if (mathAbs(readSize(n ? e : r[s]) - a) >= 0.5) {
                    o.reInit(), t.emit("resize");
                    break;
                  }
                }
              })(n);
          })),
          n.requestAnimationFrame(() => {
            a.forEach((e) => c.observe(e));
          }));
      },
      destroy: function destroy() {
        (d = !0), c && c.disconnect();
      },
    };
  }
  function ScrollBounds(e, t, n, r, o) {
    const i = o.measure(10),
      s = o.measure(50),
      a = Limit(0.1, 0.99);
    let c = !1;
    function shouldConstrain() {
      return !c && !!e.reachedAny(n.get()) && !!e.reachedAny(t.get());
    }
    return {
      shouldConstrain,
      constrain: function constrain(o) {
        if (!shouldConstrain()) return;
        const c = e.reachedMin(t.get()) ? "min" : "max",
          u = mathAbs(e[c] - t.get()),
          l = n.get() - t.get(),
          d = a.constrain(u / s);
        n.subtract(l * d),
          !o &&
            mathAbs(l) < i &&
            (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
      },
      toggleActive: function toggleActive(e) {
        c = !e;
      },
    };
  }
  function ScrollLooper(e, t, n, r) {
    const o = t.min + 0.1,
      i = t.max + 0.1,
      { reachedMin: s, reachedMax: a } = Limit(o, i);
    return {
      loop: function loop(t) {
        if (
          !(function shouldLoop(e) {
            return 1 === e ? a(n.get()) : -1 === e && s(n.get());
          })(t)
        )
          return;
        const o = e * (-1 * t);
        r.forEach((e) => e.add(o));
      },
    };
  }
  function ScrollTarget(e, t, n, r, o) {
    const { reachedAny: i, removeOffset: s, constrain: a } = r;
    function minDistance(e) {
      return e.concat().sort((e, t) => mathAbs(e) - mathAbs(t))[0];
    }
    function shortcut(t, r) {
      const o = [t, t + n, t - n];
      if (!e) return t;
      if (!r) return minDistance(o);
      const i = o.filter((e) => mathSign(e) === r);
      return i.length ? minDistance(i) : arrayLast(o) - n;
    }
    return {
      byDistance: function byDistance(n, r) {
        const c = o.get() + n,
          { index: u, distance: l } = (function findTargetSnap(n) {
            const r = e ? s(n) : a(n),
              o = t
                .map((e, t) => ({ diff: shortcut(e - r, 0), index: t }))
                .sort((e, t) => mathAbs(e.diff) - mathAbs(t.diff)),
              { index: i } = o[0];
            return { index: i, distance: r };
          })(c),
          d = !e && i(c);
        return !r || d
          ? { index: u, distance: n }
          : { index: u, distance: n + shortcut(t[u] - l, 0) };
      },
      byIndex: function byIndex(e, n) {
        return { index: e, distance: shortcut(t[e] - o.get(), n) };
      },
      shortcut,
    };
  }
  function SlideFocus(e, t, n, r, o, i, s, a) {
    const c = { passive: !0, capture: !0 };
    let u = 0;
    function registerTabPress(e) {
      "Tab" === e.code && (u = new Date().getTime());
    }
    return {
      init: function init(l) {
        a &&
          (i.add(document, "keydown", registerTabPress, !1),
          t.forEach((t, d) => {
            i.add(
              t,
              "focus",
              (t) => {
                (isBoolean(a) || a(l, t)) &&
                  (function defaultCallback(t) {
                    if (new Date().getTime() - u > 10) return;
                    s.emit("slideFocusStart"), (e.scrollLeft = 0);
                    const i = n.findIndex((e) => e.includes(t));
                    isNumber(i) &&
                      (o.useDuration(0), r.index(i, 0), s.emit("slideFocus"));
                  })(d);
              },
              c
            );
          }));
      },
    };
  }
  function Vector1D(e) {
    let t = e;
    function normalizeInput(e) {
      return isNumber(e) ? e : e.get();
    }
    return {
      get: function get() {
        return t;
      },
      set: function set(e) {
        t = normalizeInput(e);
      },
      add: function add(e) {
        t += normalizeInput(e);
      },
      subtract: function subtract(e) {
        t -= normalizeInput(e);
      },
    };
  }
  function Translate(e, t) {
    const n =
        "x" === e.scroll
          ? function x(e) {
              return `translate3d(${e}px,0px,0px)`;
            }
          : function y(e) {
              return `translate3d(0px,${e}px,0px)`;
            },
      r = t.style;
    let o = !1;
    return {
      clear: function clear() {
        o ||
          ((r.transform = ""),
          t.getAttribute("style") || t.removeAttribute("style"));
      },
      to: function to(t) {
        o || (r.transform = n(e.direction(t)));
      },
      toggleActive: function toggleActive(e) {
        o = !e;
      },
    };
  }
  function SlideLooper(e, t, n, r, o, i, s, a, c) {
    const u = 0.5,
      l = arrayKeys(o),
      d = arrayKeys(o).reverse(),
      f = (function startPoints() {
        const e = s[0];
        return findLoopPoints(slidesInGap(d, e), n, !1);
      })().concat(
        (function endPoints() {
          const e = t - s[0] - 1;
          return findLoopPoints(slidesInGap(l, e), -n, !0);
        })()
      );
    function removeSlideSizes(e, t) {
      return e.reduce((e, t) => e - o[t], t);
    }
    function slidesInGap(e, t) {
      return e.reduce(
        (e, n) => (removeSlideSizes(e, t) > 0 ? e.concat([n]) : e),
        []
      );
    }
    function findLoopPoints(o, s, l) {
      const d = (function findSlideBounds(e) {
        return i.map((n, o) => ({
          start: n - r[o] + u + e,
          end: n + t - u + e,
        }));
      })(s);
      return o.map((t) => {
        const r = l ? 0 : -n,
          o = l ? n : 0,
          i = l ? "end" : "start",
          s = d[t][i];
        return {
          index: t,
          loopPoint: s,
          slideLocation: Vector1D(-1),
          translate: Translate(e, c[t]),
          target: () => (a.get() > s ? r : o),
        };
      });
    }
    const m = {
      canLoop: function canLoop() {
        return f.every(({ index: e }) => {
          const n = l.filter((t) => t !== e);
          return removeSlideSizes(n, t) <= 0.1;
        });
      },
      clear: function clear() {
        f.forEach((e) => e.translate.clear());
      },
      loop: function loop() {
        f.forEach((e) => {
          const { target: t, translate: n, slideLocation: r } = e,
            o = t();
          o !== r.get() && (n.to(o), r.set(o));
        });
      },
      loopPoints: f,
    };
    return m;
  }
  function SlidesHandler(e, t, n) {
    let r,
      o = !1;
    return {
      init: function init(i) {
        n &&
          ((r = new MutationObserver((e) => {
            o ||
              ((isBoolean(n) || n(i, e)) &&
                (function defaultCallback(e) {
                  for (const n of e)
                    if ("childList" === n.type) {
                      i.reInit(), t.emit("slidesChanged");
                      break;
                    }
                })(e));
          })),
          r.observe(e, { childList: !0 }));
      },
      destroy: function destroy() {
        r && r.disconnect(), (o = !0);
      },
    };
  }
  function SlidesInView(e, t, n, r) {
    const o = {};
    let i,
      s = null,
      a = null,
      c = !1;
    return {
      init: function init() {
        (i = new IntersectionObserver(
          (e) => {
            c ||
              (e.forEach((e) => {
                const n = t.indexOf(e.target);
                o[n] = e;
              }),
              (s = null),
              (a = null),
              n.emit("slidesInView"));
          },
          { root: e.parentElement, threshold: r }
        )),
          t.forEach((e) => i.observe(e));
      },
      destroy: function destroy() {
        i && i.disconnect(), (c = !0);
      },
      get: function get(e = !0) {
        if (e && s) return s;
        if (!e && a) return a;
        const t = (function createInViewList(e) {
          return objectKeys(o).reduce((t, n) => {
            const r = parseInt(n),
              { isIntersecting: i } = o[r];
            return ((e && i) || (!e && !i)) && t.push(r), t;
          }, []);
        })(e);
        return e && (s = t), e || (a = t), t;
      },
    };
  }
  function SlidesToScroll(e, t, n, r, o, i, s, a, c) {
    const { startEdge: u, endEdge: l, direction: d } = e,
      f = isNumber(n);
    const m = {
      groupSlides: function groupSlides(e) {
        return f
          ? (function byNumber(e, t) {
              return arrayKeys(e)
                .filter((e) => e % t == 0)
                .map((n) => e.slice(n, n + t));
            })(e, n)
          : (function bySize(e) {
              return e.length
                ? arrayKeys(e)
                    .reduce((n, f, m) => {
                      const p = arrayLast(n) || 0,
                        g = 0 === p,
                        h = f === arrayLastIndex(e),
                        b = o[u] - i[p][u],
                        v = o[u] - i[f][l],
                        S = !r && g ? d(s) : 0,
                        L = mathAbs(v - (!r && h ? d(a) : 0) - (b + S));
                      return (
                        m && L > t + c && n.push(f), h && n.push(e.length), n
                      );
                    }, [])
                    .map((t, n, r) => {
                      const o = Math.max(r[n - 1] || 0);
                      return e.slice(o, t);
                    })
                : [];
            })(e);
      },
    };
    return m;
  }
  function Engine(e, t, n, r, o, i, s) {
    const {
        align: a,
        axis: c,
        direction: u,
        startIndex: l,
        loop: d,
        duration: f,
        dragFree: m,
        dragThreshold: p,
        inViewThreshold: g,
        slidesToScroll: h,
        skipSnaps: b,
        containScroll: v,
        watchResize: S,
        watchSlides: L,
        watchDrag: E,
        watchFocus: A,
      } = i,
      w = {
        measure: function measure(e) {
          const {
            offsetTop: t,
            offsetLeft: n,
            offsetWidth: r,
            offsetHeight: o,
          } = e;
          return {
            top: t,
            right: n + r,
            bottom: t + o,
            left: n,
            width: r,
            height: o,
          };
        },
      },
      D = w.measure(t),
      I = n.map(w.measure),
      T = (function Axis(e, t) {
        const n = "rtl" === t,
          r = "y" === e,
          o = !r && n ? -1 : 1;
        return {
          scroll: r ? "y" : "x",
          cross: r ? "x" : "y",
          startEdge: (function getStartEdge() {
            return r ? "top" : n ? "right" : "left";
          })(),
          endEdge: (function getEndEdge() {
            return r ? "bottom" : n ? "left" : "right";
          })(),
          measureSize: function measureSize(e) {
            const { height: t, width: n } = e;
            return r ? t : n;
          },
          direction: function direction(e) {
            return e * o;
          },
        };
      })(c, u),
      M = T.measureSize(D),
      P = (function PercentOfView(e) {
        return {
          measure: function measure(t) {
            return e * (t / 100);
          },
        };
      })(M),
      C = (function Alignment(e, t) {
        const n = {
          start: function start() {
            return 0;
          },
          center: function center(e) {
            return end(e) / 2;
          },
          end,
        };
        function end(e) {
          return t - e;
        }
        return {
          measure: function measure(r, o) {
            return isString(e) ? n[e](r) : e(t, r, o);
          },
        };
      })(a, M),
      O = !d && !!v,
      B = d || !!v,
      {
        slideSizes: N,
        slideSizesWithGaps: k,
        startGap: z,
        endGap: F,
      } = (function SlideSizes(e, t, n, r, o, i) {
        const { measureSize: s, startEdge: a, endEdge: c } = e,
          u = n[0] && o,
          l = (function measureStartGap() {
            if (!u) return 0;
            const e = n[0];
            return mathAbs(t[a] - e[a]);
          })(),
          d = (function measureEndGap() {
            if (!u) return 0;
            const e = i.getComputedStyle(arrayLast(r));
            return parseFloat(e.getPropertyValue(`margin-${c}`));
          })(),
          f = n.map(s),
          m = (function measureWithGaps() {
            return n
              .map((e, t, n) => {
                const r = !t,
                  o = arrayIsLastIndex(n, t);
                return r ? f[t] + l : o ? f[t] + d : n[t + 1][a] - e[a];
              })
              .map(mathAbs);
          })();
        return { slideSizes: f, slideSizesWithGaps: m, startGap: l, endGap: d };
      })(T, D, I, n, B, o),
      H = SlidesToScroll(T, M, h, d, D, I, z, F, 2),
      { snaps: _, snapsAligned: j } = (function ScrollSnaps(e, t, n, r, o) {
        const { startEdge: i, endEdge: s } = e,
          { groupSlides: a } = o,
          c = (function measureSizes() {
            return a(r)
              .map((e) => arrayLast(e)[s] - e[0][i])
              .map(mathAbs);
          })().map(t.measure),
          u = (function measureUnaligned() {
            return r.map((e) => n[i] - e[i]).map((e) => -mathAbs(e));
          })(),
          l = (function measureAligned() {
            return a(u)
              .map((e) => e[0])
              .map((e, t) => e + c[t]);
          })();
        return { snaps: u, snapsAligned: l };
      })(T, C, D, I, H),
      V = -arrayLast(_) + arrayLast(k),
      { snapsContained: q, scrollContainLimit: G } = (function ScrollContain(
        e,
        t,
        n,
        r,
        o
      ) {
        const i = Limit(-t + e, 0),
          s = (function measureBounded() {
            return n
              .map((e, t) => {
                const { min: r, max: o } = i,
                  s = i.constrain(e),
                  a = !t,
                  c = arrayIsLastIndex(n, t);
                return a
                  ? o
                  : c || usePixelTolerance(r, s)
                  ? r
                  : usePixelTolerance(o, s)
                  ? o
                  : s;
              })
              .map((e) => parseFloat(e.toFixed(3)));
          })(),
          a = (function findScrollContainLimit() {
            const e = s[0],
              t = arrayLast(s);
            return Limit(s.lastIndexOf(e), s.indexOf(t) + 1);
          })();
        function usePixelTolerance(e, t) {
          return deltaAbs(e, t) < 1;
        }
        return {
          snapsContained: (function measureContained() {
            if (t <= e + o) return [i.max];
            if ("keepSnaps" === r) return s;
            const { min: n, max: c } = a;
            return s.slice(n, c);
          })(),
          scrollContainLimit: a,
        };
      })(M, V, j, v, 2),
      R = O ? q : j,
      { limit: W } = (function ScrollLimit(e, t, n) {
        const r = t[0];
        return { limit: Limit(n ? r - e : arrayLast(t), r) };
      })(V, R, d),
      K = Counter(arrayLastIndex(R), l, d),
      $ = K.clone(),
      X = arrayKeys(n),
      U = Animations(
        r,
        o,
        (e) =>
          ((
            {
              dragHandler: e,
              scrollBody: t,
              scrollBounds: n,
              options: { loop: r },
            },
            o
          ) => {
            r || n.constrain(e.pointerDown()), t.seek(o);
          })(ue, e),
        (e) =>
          ((
            {
              scrollBody: e,
              translate: t,
              location: n,
              offsetLocation: r,
              scrollLooper: o,
              slideLooper: i,
              dragHandler: s,
              animation: a,
              eventHandler: c,
              scrollBounds: u,
              options: { loop: l },
            },
            d
          ) => {
            const f = e.settled(),
              m = !u.shouldConstrain(),
              p = l ? f : f && m;
            p && !s.pointerDown() && (a.stop(), c.emit("settle")),
              p || c.emit("scroll");
            const g = n.get() * d + Y.get() * (1 - d);
            r.set(g), l && (o.loop(e.direction()), i.loop()), t.to(r.get());
          })(ue, e)
      ),
      Q = R[K.get()],
      J = Vector1D(Q),
      Y = Vector1D(Q),
      Z = Vector1D(Q),
      ee = Vector1D(Q),
      te = (function ScrollBody(e, t, n, r, o, i) {
        let s = 0,
          a = 0,
          c = o,
          u = i,
          l = e.get(),
          d = 0;
        function useDuration(e) {
          return (c = e), f;
        }
        function useFriction(e) {
          return (u = e), f;
        }
        const f = {
          direction: function direction() {
            return a;
          },
          duration: function duration() {
            return c;
          },
          velocity: function velocity() {
            return s;
          },
          seek: function seek(t) {
            const o = t / 1e3,
              i = c * o,
              m = r.get() - e.get();
            let p = 0;
            return (
              c
                ? (n.set(e),
                  (s += m / i),
                  (s *= u),
                  (l += s),
                  e.add(s * o),
                  (p = l - d))
                : ((s = 0), n.set(r), e.set(r), (p = m)),
              (a = mathSign(p)),
              (d = l),
              f
            );
          },
          settled: function settled() {
            return mathAbs(r.get() - t.get()) < 0.001;
          },
          useBaseFriction: function useBaseFriction() {
            return useFriction(i);
          },
          useBaseDuration: function useBaseDuration() {
            return useDuration(o);
          },
          useFriction,
          useDuration,
        };
        return f;
      })(J, Z, Y, ee, f, 0.68),
      ne = ScrollTarget(d, R, V, W, ee),
      re = (function ScrollTo(e, t, n, r, o, i, s) {
        function scrollTo(o) {
          const a = o.distance,
            c = o.index !== t.get();
          i.add(a),
            a &&
              (r.duration()
                ? e.start()
                : (e.update(), e.render(1), e.update())),
            c && (n.set(t.get()), t.set(o.index), s.emit("select"));
        }
        return {
          distance: function distance(e, t) {
            scrollTo(o.byDistance(e, t));
          },
          index: function index(e, n) {
            const r = t.clone().set(e);
            scrollTo(o.byIndex(r.get(), n));
          },
        };
      })(U, K, $, te, ne, ee, s),
      oe = (function ScrollProgress(e) {
        const { max: t, length: n } = e;
        return {
          get: function get(e) {
            return n ? (e - t) / -n : 0;
          },
        };
      })(W),
      ie = EventStore(),
      se = SlidesInView(t, n, s, g),
      { slideRegistry: ae } = (function SlideRegistry(e, t, n, r, o, i) {
        const { groupSlides: s } = o,
          { min: a, max: c } = r;
        return {
          slideRegistry: (function createSlideRegistry() {
            const r = s(i),
              o = !e || "keepSnaps" === t;
            return 1 === n.length
              ? [i]
              : o
              ? r
              : r.slice(a, c).map((e, t, n) => {
                  const r = !t,
                    o = arrayIsLastIndex(n, t);
                  return r
                    ? arrayFromNumber(arrayLast(n[0]) + 1)
                    : o
                    ? arrayFromNumber(
                        arrayLastIndex(i) - arrayLast(n)[0] + 1,
                        arrayLast(n)[0]
                      )
                    : e;
                });
          })(),
        };
      })(O, v, R, G, H, X),
      ce = SlideFocus(e, n, ae, re, te, ie, s, A),
      ue = {
        ownerDocument: r,
        ownerWindow: o,
        eventHandler: s,
        containerRect: D,
        slideRects: I,
        animation: U,
        axis: T,
        dragHandler: DragHandler(
          T,
          e,
          r,
          o,
          ee,
          DragTracker(T, o),
          J,
          U,
          re,
          te,
          ne,
          K,
          s,
          P,
          m,
          p,
          b,
          0.68,
          E
        ),
        eventStore: ie,
        percentOfView: P,
        index: K,
        indexPrevious: $,
        limit: W,
        location: J,
        offsetLocation: Z,
        previousLocation: Y,
        options: i,
        resizeHandler: ResizeHandler(t, s, o, n, T, S, w),
        scrollBody: te,
        scrollBounds: ScrollBounds(W, Z, ee, te, P),
        scrollLooper: ScrollLooper(V, W, Z, [J, Z, Y, ee]),
        scrollProgress: oe,
        scrollSnapList: R.map(oe.get),
        scrollSnaps: R,
        scrollTarget: ne,
        scrollTo: re,
        slideLooper: SlideLooper(T, M, V, N, k, _, R, Z, n),
        slideFocus: ce,
        slidesHandler: SlidesHandler(t, s, L),
        slidesInView: se,
        slideIndexes: X,
        slideRegistry: ae,
        slidesToScroll: H,
        target: ee,
        translate: Translate(T, t),
      };
    return ue;
  }
  e.r(t), e.d(t, { GlobalCarousel: () => GlobalCarousel });
  const n = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: !1,
    dragThreshold: 10,
    loop: !1,
    skipSnaps: !1,
    duration: 25,
    startIndex: 0,
    active: !0,
    watchDrag: !0,
    watchResize: !0,
    watchSlides: !0,
    watchFocus: !0,
  };
  function OptionsHandler(e) {
    function mergeOptions(e, t) {
      return objectsMergeDeep(e, t || {});
    }
    const t = {
      mergeOptions,
      optionsAtMedia: function optionsAtMedia(t) {
        const n = t.breakpoints || {},
          r = objectKeys(n)
            .filter((t) => e.matchMedia(t).matches)
            .map((e) => n[e])
            .reduce((e, t) => mergeOptions(e, t), {});
        return mergeOptions(t, r);
      },
      optionsMediaQueries: function optionsMediaQueries(t) {
        return t
          .map((e) => objectKeys(e.breakpoints || {}))
          .reduce((e, t) => e.concat(t), [])
          .map(e.matchMedia);
      },
    };
    return t;
  }
  function EmblaCarousel(e, t, r) {
    const o = e.ownerDocument,
      i = o.defaultView,
      s = OptionsHandler(i),
      a = (function PluginsHandler(e) {
        let t = [];
        return {
          init: function init(n, r) {
            return (
              (t = r.filter(
                ({ options: t }) => !1 !== e.optionsAtMedia(t).active
              )),
              t.forEach((t) => t.init(n, e)),
              r.reduce((e, t) => Object.assign(e, { [t.name]: t }), {})
            );
          },
          destroy: function destroy() {
            t = t.filter((e) => e.destroy());
          },
        };
      })(s),
      c = EventStore(),
      u = (function EventHandler() {
        let e,
          t = {};
        function getListeners(e) {
          return t[e] || [];
        }
        const n = {
          init: function init(t) {
            e = t;
          },
          emit: function emit(t) {
            return getListeners(t).forEach((n) => n(e, t)), n;
          },
          off: function off(e, r) {
            return (t[e] = getListeners(e).filter((e) => e !== r)), n;
          },
          on: function on(e, r) {
            return (t[e] = getListeners(e).concat([r])), n;
          },
          clear: function clear() {
            t = {};
          },
        };
        return n;
      })(),
      { mergeOptions: l, optionsAtMedia: d, optionsMediaQueries: f } = s,
      { on: m, off: p, emit: g } = u,
      h = reActivate;
    let b,
      v,
      S,
      L,
      E = !1,
      A = l(n, EmblaCarousel.globalOptions),
      w = l(A),
      D = [];
    function createEngine(t) {
      const n = Engine(e, S, L, o, i, t, u);
      if (t.loop && !n.slideLooper.canLoop()) {
        return createEngine(Object.assign({}, t, { loop: !1 }));
      }
      return n;
    }
    function activate(t, n) {
      E ||
        ((A = l(A, t)),
        (w = d(A)),
        (D = n || D),
        (function storeElements() {
          const { container: t, slides: n } = w,
            r = isString(t) ? e.querySelector(t) : t;
          S = r || e.children[0];
          const o = isString(n) ? S.querySelectorAll(n) : n;
          L = [].slice.call(o || S.children);
        })(),
        (b = createEngine(w)),
        f([A, ...D.map(({ options: e }) => e)]).forEach((e) =>
          c.add(e, "change", reActivate)
        ),
        w.active &&
          (b.translate.to(b.location.get()),
          b.animation.init(),
          b.slidesInView.init(),
          b.slideFocus.init(I),
          b.eventHandler.init(I),
          b.resizeHandler.init(I),
          b.slidesHandler.init(I),
          b.options.loop && b.slideLooper.loop(),
          S.offsetParent && L.length && b.dragHandler.init(I),
          (v = a.init(I, D))));
    }
    function reActivate(e, t) {
      const n = selectedScrollSnap();
      deActivate(), activate(l({ startIndex: n }, e), t), u.emit("reInit");
    }
    function deActivate() {
      b.dragHandler.destroy(),
        b.eventStore.clear(),
        b.translate.clear(),
        b.slideLooper.clear(),
        b.resizeHandler.destroy(),
        b.slidesHandler.destroy(),
        b.slidesInView.destroy(),
        b.animation.destroy(),
        a.destroy(),
        c.clear();
    }
    function scrollTo(e, t, n) {
      w.active &&
        !E &&
        (b.scrollBody.useBaseFriction().useDuration(!0 === t ? 0 : w.duration),
        b.scrollTo.index(e, n || 0));
    }
    function selectedScrollSnap() {
      return b.index.get();
    }
    const I = {
      canScrollNext: function canScrollNext() {
        return b.index.add(1).get() !== selectedScrollSnap();
      },
      canScrollPrev: function canScrollPrev() {
        return b.index.add(-1).get() !== selectedScrollSnap();
      },
      containerNode: function containerNode() {
        return S;
      },
      internalEngine: function internalEngine() {
        return b;
      },
      destroy: function destroy() {
        E || ((E = !0), c.clear(), deActivate(), u.emit("destroy"), u.clear());
      },
      off: p,
      on: m,
      emit: g,
      plugins: function plugins() {
        return v;
      },
      previousScrollSnap: function previousScrollSnap() {
        return b.indexPrevious.get();
      },
      reInit: h,
      rootNode: function rootNode() {
        return e;
      },
      scrollNext: function scrollNext(e) {
        scrollTo(b.index.add(1).get(), e, -1);
      },
      scrollPrev: function scrollPrev(e) {
        scrollTo(b.index.add(-1).get(), e, 1);
      },
      scrollProgress: function scrollProgress() {
        return b.scrollProgress.get(b.location.get());
      },
      scrollSnapList: function scrollSnapList() {
        return b.scrollSnapList;
      },
      scrollTo,
      selectedScrollSnap,
      slideNodes: function slideNodes() {
        return L;
      },
      slidesInView: function slidesInView() {
        return b.slidesInView.get();
      },
      slidesNotInView: function slidesNotInView() {
        return b.slidesInView.get(!1);
      },
    };
    return activate(t, r), setTimeout(() => u.emit("init"), 0), I;
  }
  (EmblaCarousel.globalOptions = void 0),
    (EmblaCarousel.globalOptions = { watchSlides: !1 });
  class ObservableTimeout {
    constructor(e) {
      (this.ObserverLite = new ObserverLite()),
        (this.timeout = !1),
        (this.delay = e || 5e3);
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
    stop() {
      this?.timeout && clearTimeout(this.timeout);
    }
    go() {
      this &&
        (this.stop(),
        (this.timeout = setTimeout(() => {
          this.next(), this.go();
        }, this.delay)));
    }
    setDelay(e) {
      (this.delay = e), this.go();
    }
  }
  function EmblaCarouselAutoplay(e, t) {
    const n = e?.delay || 5e3,
      r = t.rootNode(),
      o = new ObservableTimeout(n);
    let i,
      s,
      a = !1;
    (window.onload = () => {
      o.go();
    }),
      o.subscribe(() => {
        t.canScrollNext() ? t.scrollNext() : t.scrollTo(0);
      }),
      t.on("reInit", o.go),
      t.on("pointerUp", o.go),
      t.on("pointerDown", o.stop);
    const conditionallyPauseAutoPlay = () => {
        a || o.stop();
      },
      conditionallyResumeAutoPlay = () => {
        a || o.go();
      };
    r.addEventListener("touchstart", conditionallyPauseAutoPlay),
      r.addEventListener("touchend", conditionallyPauseAutoPlay),
      r.addEventListener("mouseover", conditionallyPauseAutoPlay),
      r.addEventListener("touchcancel", conditionallyResumeAutoPlay),
      r.addEventListener("mouseout", conditionallyResumeAutoPlay),
      window.addEventListener("load", () => {
        r.matches(":hover") && conditionallyPauseAutoPlay();
      }),
      (i = () => {
        (a = !0), o.stop();
      }),
      (s = () => {
        (a = !1), o.go();
      });
    return {
      type: "autoplay",
      get paused() {
        return a;
      },
      pause: i,
      play: s,
      setDelay: (e) => {
        o.setDelay(e);
      },
    };
  }
  function EmblaCarouselScrollbar(e = {}, t) {
    let n,
      r,
      o = t.internalEngine(),
      i = 0,
      s = 1,
      a = !1,
      c = 0,
      u = 0;
    function mapToScroll() {
      const { target: n } = e;
      (i = t.scrollProgress()), (i = i > 1 ? 1 : i < 0 ? 0 : i);
      const o = n.offsetWidth - r.offsetWidth;
      r.style.transform = `translateX(${o * i}px)`;
    }
    function resetCursorAndMouseDownState() {
      (a = !1),
        (r.style.cursor = "grab"),
        document.removeEventListener("mousemove", onDragMove),
        document.removeEventListener("mouseup", resetCursorAndMouseDownState),
        document.removeEventListener(
          "mouseleave",
          resetCursorAndMouseDownState
        ),
        document.removeEventListener("touchmove", onDragMove),
        document.removeEventListener("touchend", resetCursorAndMouseDownState),
        document.body.classList.remove("embla__dragging"),
        (c = 0);
    }
    function onDragStart(e) {
      e.preventDefault(),
        (a = !0),
        (r.style.cursor = "grabbing"),
        (c = (e.pageX || e.touches[0].pageX) - n.offsetLeft),
        (u =
          parseInt(
            r.style.transform.replace("translateX(", "").replace("px)", "")
          ) || 0),
        document.body.classList.add("embla__dragging"),
        document.addEventListener("mousemove", onDragMove),
        document.addEventListener("mouseup", resetCursorAndMouseDownState),
        document.addEventListener("mouseleave", resetCursorAndMouseDownState),
        document.addEventListener("touchmove", onDragMove, { passive: !1 }),
        document.addEventListener("touchend", resetCursorAndMouseDownState);
    }
    function onDragMove(e) {
      if (!a) return;
      e.preventDefault();
      const t = (e.pageX || e.touches[0].pageX) - n.offsetLeft;
      let o = u + (t - c);
      const i = n.offsetWidth - r.offsetWidth;
      o < 0 && (o = 0),
        o > i && (o = i),
        (r.style.transform = `translateX(${o}px)`),
        updateCarouselScrollPosition(o, i);
    }
    function updateCarouselScrollPosition(e, t) {
      const n = o.scrollSnaps;
      let r = e / t;
      (r *= n[n.length - 1]), o.translate.to(r);
    }
    function onScrollbarClick(e) {
      if (e.target === r) return;
      const t = e.pageX - n.getBoundingClientRect().left,
        o = r.offsetWidth,
        i = n.offsetWidth - o;
      let s = t - o / 2;
      s < 0 && (s = 0),
        s > i && (s = i),
        (r.style.transform = `translateX(${s}px)`),
        updateCarouselScrollPosition(s, i);
    }
    function updateSize() {
      const { target: o } = e;
      n.style.width = "100%";
      const i = t.containerNode();
      s = i.scrollWidth / i.offsetWidth;
      const a = o.offsetWidth / s;
      (r.style.width = `${a}px`), mapToScroll();
    }
    e.target &&
      !o.options.loop &&
      (function build() {
        const { target: i } = e;
        n ||
          i.dataset.init ||
          ((i.dataset.init = !0),
          (n = document.createElement("div")),
          (r = document.createElement("div")),
          n.appendChild(r),
          i.appendChild(n),
          (n.style.height = "4px"),
          (n.style.background = "rgba(0,0,0,.1)"),
          (r.style.height = "100%"),
          (r.style.background = "#000"),
          (r.style.cursor = "grab"),
          Array.from(["init", "reInit", "scroll", "settle"]).forEach((e) =>
            t.on(e, mapToScroll)
          ),
          r.addEventListener("mousedown", onDragStart),
          r.addEventListener("touchstart", onDragStart, { passive: !1 }),
          n.addEventListener("click", onScrollbarClick),
          updateSize(),
          t.on("resize", (e) => {
            (t = e), (o = e.internalEngine()), updateSize();
          }));
      })();
    return { type: "scrollbar" };
  }
  function EmblaNav(e = {}, t) {
    e.prevBtn &&
      e.nextBtn &&
      (function addPrevNextBtnsClickHandlers() {
        const scrollPrev = () => t.scrollPrev(),
          scrollNext = () => t.scrollNext();
        e.prevBtn.addEventListener("click", scrollPrev, !1),
          e.nextBtn.addEventListener("click", scrollNext, !1);
        const n = (function addTogglePrevNextBtnsActive() {
          const togglePrevNextBtnsState = () => {
            t.canScrollPrev()
              ? e.prevBtn.removeAttribute("disabled")
              : e.prevBtn.setAttribute("disabled", "disabled"),
              t.canScrollNext()
                ? e.nextBtn.removeAttribute("disabled")
                : e.nextBtn.setAttribute("disabled", "disabled");
          };
          return (
            t
              .on("select", togglePrevNextBtnsState)
              .on("init", togglePrevNextBtnsState)
              .on("reInit", togglePrevNextBtnsState),
            () => {
              e.prevBtn.removeAttribute("disabled"),
                e.nextBtn.removeAttribute("disabled");
            }
          );
        })();
        return (
          t.on("destroy", addPrevNextBtnsClickHandlers),
          () => {
            n(),
              e.prevBtn.removeEventListener("click", scrollPrev, !1),
              e.nextBtn.removeEventListener("click", scrollNext, !1);
          }
        );
      })(),
      e.dotsNode &&
        (function addDotBtnsAndClickHandlers() {
          let n = [];
          const addDotBtnsWithClickHandlers = () => {
              (e.dotsNode.innerHTML = t
                .scrollSnapList()
                .map(
                  () =>
                    '<button class="global-carousel__dot" type="button"></button>'
                )
                .join("")),
                (n = Array.from(
                  e.dotsNode.querySelectorAll(".global-carousel__dot")
                )),
                n.forEach((e, n) => {
                  e.addEventListener("click", () => t.scrollTo(n), !1);
                });
            },
            toggleDotBtnsActive = () => {
              e.dotsNode.style.display =
                t.canScrollPrev() || t.canScrollNext() ? "block" : "none";
              const r = t.previousScrollSnap(),
                o = t.selectedScrollSnap();
              n[r]?.classList?.remove("global-carousel__dot--selected"),
                n[o]?.classList?.add("global-carousel__dot--selected");
            };
          return (
            t
              .on("init", addDotBtnsWithClickHandlers)
              .on("destroy", addDotBtnsWithClickHandlers)
              .on("reInit", addDotBtnsWithClickHandlers)
              .on("init", toggleDotBtnsActive)
              .on("reInit", toggleDotBtnsActive)
              .on("select", toggleDotBtnsActive),
            () => {
              e.dotsNode.innerHTML = "";
            }
          );
        })();
    return { type: "nav" };
  }
  class GlobalCarousel extends HTMLElement {
    constructor() {
      super(), (this.embla = null);
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
    connectedCallback() {
      DomReadyPromise()
        .then(async () => {
          this.ObserverLite = new ObserverLite();
          let e = this.querySelector(":scope > template");
          if (e) {
            try {
              this.settings = JSON.parse(e.innerHTML);
            } catch (e) {
              console.error(e);
            }
            e.remove(), (e = null);
          }
          this.init();
        })
        .catch((e) => {
          console.error(e);
        });
    }
    init() {
      if (
        (this.settings?.options &&
          this.querySelector(".global-carousel__items") &&
          (this.embla = new EmblaCarousel(
            this.querySelector(".global-carousel__items"),
            this.settings.options
          )),
        this.settings?.plugins)
      ) {
        const e = {
          autoplay: EmblaCarouselAutoplay,
          nav: EmblaNav,
          scrollbar: EmblaCarouselScrollbar,
        };
        Object.keys(this.settings.plugins).forEach((t) => {
          const n = this.settings.plugins[t];
          "scrollbar" == t &&
            (n.target = n.target
              ? this.querySelector(n.target)
              : this.querySelector(".global-carousel__scrollbar")),
            "nav" == t &&
              ((n.dotsNode = n.dotsNode
                ? this.querySelector(n.dotsNode)
                : this.querySelector(".global-carousel__pagination")),
              (n.nextBtn = n.nextBtn
                ? this.querySelector(n.nextBtn)
                : this.querySelector(".global-carousel__nav-next")),
              (n.prevBtn = n.prevBtn
                ? this.querySelector(n.prevBtn)
                : this.querySelector(".global-carousel__nav-prev")));
          const r = e[t](n, this.embla);
          (this.plugins = this.plugins || []), this.plugins.push(r);
        });
      }
      ((e, t = 150, n = 15) => {
        const r = `component-initialisation-${e}`,
          o = `initialisation-confirmed-${this.dataset.compId}`;
        let i = 0,
          s = !1;
        const confirmHandler = () => {
          (s = !0),
            document.removeEventListener(o, confirmHandler),
            clearInterval(a);
        };
        document.addEventListener(o, confirmHandler);
        const a = setInterval(() => {
          if (s || i >= n)
            return (
              clearInterval(a),
              void (
                s ||
                console.warn(
                  `Initialisation for ${r} failed after ${n} attempts`
                )
              )
            );
          document.dispatchEvent(new CustomEvent(r)), i++;
        }, t);
        document.dispatchEvent(new CustomEvent(r)), i++;
      })(this.dataset.compId),
        this.next({ init: !0 });
    }
    destroy() {
      this.embla && (this.embla.destroy(), (this.embla = null));
    }
  }
  const r = `global-carousel-${document.currentScript.dataset.compId}`;
  customElements.get(r) || customElements.define(r, GlobalCarousel);
  var o = self;
  for (var i in t) o[i] = t[i];
  t.__esModule && Object.defineProperty(o, "__esModule", { value: !0 });
})();
